/**
 * Configuration OAuth pour FiverFlow
 * Gère les URLs de redirection selon l'environnement
 * 
 * IMPORTANT: Pour que "FiverFlow" s'affiche au lieu de "WhyyExoo" dans les popups OAuth,
 * vous devez configurer dans le dashboard Supabase:
 * 1. Authentication > URL Configuration > Site URL: https://fiverflow2-0.vercel.app (ou votre domaine)
 * 2. Authentication > URL Configuration > Redirect URLs: Ajouter https://fiverflow2-0.vercel.app/auth/callback
 * 3. Authentication > Providers > [GitHub/Google/Discord] > Authorized redirect URIs: 
 *    - https://arnuyyyryvbfcvqauqur.supabase.co/auth/v1/callback
 * 4. Authentication > Settings > Application Name: "FiverFlow" (au lieu de "WhyyExoo")
 */

const getAppUrl = (): string => {
  // Utiliser VITE_APP_URL si défini, sinon détecter automatiquement
  const appUrl = import.meta.env.VITE_APP_URL || window.location.origin;
  return appUrl;
};

export const getOAuthRedirectUrl = (): string => {
  const appUrl = getAppUrl();
  // Toujours rediriger vers /auth/callback qui gère ensuite la redirection vers /dashboard
  return `${appUrl}/auth/callback`;
};

export const oauthConfig = {
  redirectTo: getOAuthRedirectUrl(),
  queryParams: {
    access_type: 'offline' as const,
    prompt: 'consent' as const,
  },
  // Options supplémentaires pour personnaliser l'expérience OAuth
  options: {
    // S'assurer que la redirection se fait vers notre domaine Fiverflow, pas Supabase
    skipBrowserRedirect: false,
    // Utiliser le domaine de l'application au lieu de celui de Supabase
    // Cela permet d'afficher "Fiverflow" au lieu des liens de la base de données
    redirectTo: getOAuthRedirectUrl(),
  }
}
